/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useGetChatList } from 'app/core/api/repairer/api-repairer';
import {
  RepairCase,
  CaseStatus,
} from 'app/core/api/repairer/api-repairer.types';
import LoadingOverlay from 'app/shared/page-parts/LoadingOverlay';
import SharedRoutePath from 'app/shared/SharedRoutePath';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { TileContainer } from '../../../shared/frames/Tile';
import ProductSliderContainer from './ProductSliderContainer';

export default function InProgressProducts(): JSX.Element {
  const history = useHistory();
  const { resource: chatList, loadingMissing } = useGetChatList();
  const [newProducts, setNewProducts] = useState<RepairCase[]>();
  const [count, setCount] = useState<number>(0);
  useEffect(() => {
    const np = chatList
      ?.filter(
        m =>
          m.status &&
          // m.caseStatus === 'in_progress' &&
          m.status !== 'new' &&
          m.status !== 'resolved' &&
          m.status !== 'failed' &&
          m.status !== 'abandoned' &&
          m.status !== 'item_collected' &&
          m.status !== null
      )
      .sort((c1, c2) => {
        const v1 =
          new Date(c1.lastEvent?.created || '').valueOf() || 0;
        const v2 =
          new Date(c2.lastEvent?.created || '').valueOf() || 0;
        return v2 - v1; // descending = largest date first = newest first
      });
    setNewProducts(np);
    const inp = chatList
      ?.filter(m => m.chatListStatus === CaseStatus.IN_PROGRESS)
      .sort((c1, c2) => {
        const v1 =
          new Date(c1.lastEvent?.created || '').valueOf() || 0;
        const v2 =
          new Date(c2.lastEvent?.created || '').valueOf() || 0;
        return v2 - v1; // descending = largest date first = newest first
      });
    setCount(inp?.length || 0);
  }, [chatList]);

  return (
    <div
      style={{
        width: '100%',
        display: newProducts && newProducts.length ? 'block' : 'none',
      }}
    >
      <LoadingOverlay loadingComplete={!loadingMissing} />
      {chatList && chatList?.length > 0 && (
        <>
          <div style={{ display: 'flex' }}>
            <h3
              style={{
                color: '#31AD31',
                flexGrow: 1,
                fontWeight: 'normal',
              }}
            >
              Under Repair
            </h3>
            <h3
              style={{
                color: '#31AD31',
                flexGrow: 1,
                textAlign: 'right',
                fontWeight: 'normal',
              }}
              onClick={() =>
                history.push(
                  `${SharedRoutePath.CHAT_LIST}/inProgress`
                )
              }
            >
              {newProducts && newProducts.length > 0 && (
                <span style={{ position: 'absolute', right: '10px' }}>
                  See All ({count})
                </span>
              )}
            </h3>
          </div>
          <div style={{ marginLeft: '-10px' }}>
            <TileContainer>
              {newProducts && (
                <ProductSliderContainer
                  products={newProducts}
                  variantType="wide"
                  displayType="withTracking"
                />
              )}
            </TileContainer>
          </div>
        </>
      )}
    </div>
  );
}
